<template>
  <v-row dense no-gutters>
    <v-col cols="8">
      <project-properties-table :project="project" :value="currentProperty" :decorateNumerals="true" @input="onPropertyChanged"/>
    </v-col>
    <v-col cols="4">
      <comp-property-card :property="currentProperty.length ? currentProperty[0] : {}" :mode="'viewer'" :full-view="true"/>
    </v-col>
    <prj-add-project-property-dialog :property="currentProperty" :project="project" v-model="showAddProperty" @propertyAdded="onAddProp" @propertyUpdate="onUpdateProp"/>
    <sys-confirm-dialog :value="dlgShowConfirm" :message="'Подтвердите удаление'" :no-call-back="cancelConfirmDialog" :ok-call-back="doDeleteCompProp"/>
  </v-row>
</template>

<script>
import ProjectPropertiesTable from '@/components/modules/projects/ui/projectPropertiesTable'
import CompPropertyCard from '@/components/modules/projects/cards/configuration/compPropertyCard'
import { UI_ADD_ACTION, UI_SET_ACTIONS, UI_SNACKBAR } from '@/store/actions/ui'
import PrjAddProjectPropertyDialog from '@/components/modules/projects/dialogs/prjAddProjectPropertyDialog'
import axios from 'axios'
import SysConfirmDialog from '@/components/common/dialogs/confirmDialog'

export default {
  name: 'projectPropertiesCard',
  components: { SysConfirmDialog, PrjAddProjectPropertyDialog, CompPropertyCard, ProjectPropertiesTable },
  props: ['project', 'activeTab'],
  data () {
    return {
      addProperty: { text: 'Добавить свойство', actionType: 'Свойства', action: 'addRcptProp', method: this.addRcptProperty, icon: 'mdi-plus', params: '' },
      editProperty: { text: 'Изменить свойство', actionType: 'Свойства', action: 'updRcptProp', method: this.updRcptProperty, icon: 'mdi-pencil', params: '' },
      delProperty: { text: 'Удалить свойство', actionType: 'Свойства', action: 'delRcptProp', method: this.delRcptProperty, icon: 'mdi-close', params: '' },
      currentProperty: [],
      dlgShowConfirm: false,
      showAddProperty: false
    }
  },
  watch: {
    activeTab (val) {
      this.setActions()
    }
  },
  methods: {
    setActions () {
      this.$store.dispatch(UI_SET_ACTIONS, {
        actionType: 'Свойства',
        actions: []
      })
      if (this.activeTab === 'tabProperties') {
        this.$store.dispatch(UI_ADD_ACTION, this.addProperty)
        if (this.currentProperty.length > 0) {
          this.$store.dispatch(UI_ADD_ACTION, this.editProperty)
          this.$store.dispatch(UI_ADD_ACTION, this.delProperty)
        }
      }
    },
    addRcptProperty () {
      this.currentProperty.splice(0, 1)
      this.showAddProperty = true
    },
    updRcptProperty () {
      console.log('projectPropertiesCard calling updRcptProperty with active property ', this.currentProperty)
      this.showAddProperty = true
    },
    onPropertyChanged (val) {
      console.log('projectPropertiesCard onPropertyChanged called with val ', val)
      this.currentProperty.splice(0, 1, ...val)
      this.setActions()
    },
    onAddProp (val) {
      this.$emit('onChange', {})
      this.onPropertyChanged(val)
      this.showAddProperty = false
    },
    onUpdateProp (val) {
      this.onPropertyChanged(val)
      this.showAddProperty = false
    },
    delRcptProperty () {
      console.log('Calling for confirm dialog')
      this.dlgShowConfirm = true
    },
    cancelConfirmDialog () {
      this.dlgShowConfirm = false
    },
    doDeleteCompProp () {
      console.log('Closing confirm dialog')
      this.dlgShowConfirm = false
      const processorPath = '/api/org/receptures/rcptDelRcptProperty.php'
      const payload = { ...this.currentProperty[0] }
      axios({
        url: processorPath,
        method: 'POST',
        data: payload
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            this.currentProperty.splice(0, 1, { action: 'delete', PROP_ID: this.currentProperty[0].PROP_ID })
            this.$emit('onChange', {})
          } else {
            this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${err}` })
        })
    }
  },
  mounted () {
    this.setActions()
  },
  created () {
  }
}
</script>
